export { lemmonDark } from "./themes/lemmonDark";
export { lemmonLight } from "./themes/lemmonLight";
export { lemmonBlack } from "./themes/lemmonBlack";
export { lemmonMidnight } from "./themes/lemmonMidnight";
export { lemmonPaper } from "./themes/lemmonPaper";
export { lemmonSunset } from "./themes/lemmonSunset";
export { lemmonSnow } from "./themes/lemmonSnow";

export type ThemeOption = {
  id: string;
  label: string;
  isDark: boolean;
  base100: string;
  primary: string;
};

export const themeOptions: ThemeOption[] = [
  {
    id: "lemmonDark",
    label: "Dark",
    isDark: true,
    base100: "#1d232a",
    primary: "#047aff",
  },
  {
    id: "lemmonBlack",
    label: "Black",
    isDark: true,
    base100: "#000000",
    primary: "#00d9a3",
  },
  {
    id: "lemmonSunset",
    label: "Sunset",
    isDark: false,
    base100: "#fff8f0",
    primary: "#ff6b4a",
  },
  {
    id: "lemmonSnow",
    label: "Snow",
    isDark: false,
    base100: "#ffffff",
    primary: "#7c3aed",
  },
  //  {
  //    id: "lemmonMidnight",
  //    label: "Midnight",
  //    isDark: true,
  //    base100: "#191730",
  //    primary: "#a78bfa",
  //  },
  //  {
  //    id: "lemmonLight",
  //    label: "Light",
  //    isDark: false,
  //    base100: "#ffffff",
  //    primary: "#047aff",
  //  },
  //  {
  //    id: "lemmonPaper",
  //    label: "Paper",
  //    isDark: false,
  //    base100: "#ffffff",
  //    primary: "#0e63d8",
  //  },
];

export const DEFAULT_THEME = "lemmonDark";
